import { createRouter, createWebHistory } from "vue-router";
import { isUserLoggedIn } from "@/helpers/accessManager";

import Home from "../views/HomeView.vue";
import ClientsList from "../views/clients/ClientsList.vue";
import MeasurementsForm from "../components/forms/MeasurementsForm.vue";
import ClientView from "../views/clients/ClientView.vue";
import ModelView from "../views/models/ModelView.vue";
import ClientCreate from "@/views/clients/ClientCreate.vue";
import ModelCreate from "@/views/models/ModelCreate.vue";
import MeasurementsCreate from "@/views/measurements/MeasurementsCreate.vue";
import TissuCreate from "@/views/tissus/TissuCreate.vue";
import TissuView from "@/views/tissus/TissuView.vue";
import Register from "@/views/auth/Register.vue";
import Login from "@/views/auth/Login.vue";
import AppLayout from "@/layouts/AppLayout.vue";
import Me from "@/views/auth/Me.vue";
import UserList from "@/views/users/UserList.vue";
import UserCreate from "@/views/users/UserCreate.vue";
import UserView from "@/views/users/UserView.vue";
import NotFoundView from "@/views/notFound/NotFoundView.vue";
import TissuTypeList from "@/views/tissu_types/TissuTypeList.vue";
import CatalogueList from "@/views/catalogues/CatalogueList.vue";
import CatalogQr from "@/views/catalogues/CatalogQr.vue";
import ModelList from "@/views/models/ModelList.vue";
import WalletView from "@/views/wallets/WalletView.vue";
import CatalogCreate from "@/views/catalogues/CatalogCreate.vue";
import Atelier from "@/views/atelier/Atelier.vue";
import AtelierEdit from "@/views/atelier/AtelierEdit.vue";
import CatalogueClientList from "@/views/catalogues/CatalogueClientList.vue";
import ClientFromOrderForm from "@/components/forms/ClientFromOrderForm.vue";
import CartView from "@/views/clients/CartView.vue";
import NotAuthLayout from "@/layouts/NotAuthLoyaut.vue";

const routes = [
  // Auth
  { path: "/login", name: "login", component: Login },
  { path: "/register", name: "register", component: Register },

  // Not Auth
  {
    path: "/n-a",
    name: "NotAuthLayout",
    component: NotAuthLayout,
    children: [
      { path: "/catalogues_for_clients/:tenant_id", name: "catalogues_for_clients", component: CatalogueClientList, props: true },
      { path: "/orders_from_clients/:tenant_id/:catalog_id", name: "orders_from_clients", component: ClientFromOrderForm, props: true },
      { path: "/cart/:tenant_id/", name: "cart", component: CartView, props: true },

    ]
  },

  // App
  {
    path: "/",
    name: "app",
    component: AppLayout,
    redirect: { name: "home" },
    meta: {
      requireAuth: true,
    },
    children: [
      { path: "/#", name: "home", component: Home },
      { path: "/auth/me", name: "auth-user", component: Me },
      { path: "/clients", name: "clients", component: ClientsList },
      { path: "/orders", name: "orders.index", component: ModelList },
      {
        path: "/clients/create",
        name: "clients.create",
        component: ClientCreate,
      },
      {
        path: "/clients/:id",
        name: "clients.view",
        component: ClientView,
        props: true,
      },
      {
        path: "/clients/:id/edit",
        name: "clients.edit",
        component: ClientCreate,
        props: true,
      },
      {
        path: "/clients/:client_id/models/create",
        name: "models.create",
        component: ModelCreate,
        props: true,
      },
      {
        path: "/clients/:client_id/models/edit/:id",
        name: "models.edit",
        component: ModelCreate,
        props: true,
      },
      {
        path: "/models/:id",
        name: "models.view",
        component: ModelView,
        props: true,
      },
      {
        path: "/measurements",
        name: "measurements",
        component: MeasurementsForm,
      },
      {
        path: "/clients/:client_id/measurements/create",
        name: "measurements.create",
        component: MeasurementsCreate,
        props: true,
      },
      {
        path: "/clients/:client_id/measurements/edit/:id",
        name: "measurements.edit",
        component: MeasurementsCreate,
        props: true,
      },
      {
        path: "/models/:model_id/tissus/create",
        name: "tissus.create",
        component: TissuCreate,
        props: true,
      },
      {
        path: "/models/:model_id/tissus/edit/:id",
        name: "tissus.edit",
        component: TissuCreate,
        props: true,
      },
      {
        path: "/tissus/:id",
        name: "tissus.view",
        component: TissuView,
        props: true,
      },
      {
        path: "/tissu_types",
        name: "tissu_types.index",
        component: TissuTypeList,
      },

      //Catalogues
      { path: "/catalogues", name: "catalogues.index", component: CatalogueList },
      { path: "/catalogues/qr", name: "catalogues.qr", component: CatalogQr },
      { path: "/catalogues/create", name: "catalogues.create", component: CatalogCreate },
      { path: "/catalogues/:id/edit", name: "catalogues.edit", component: CatalogCreate, props: true },

      //Users
      { path: "/users", name: "users.index", component: UserList },
      { path: "/users/create", name: "users.create", component: UserCreate },
      {
        path: "/users/:id",
        name: "users.view",
        component: UserView,
        props: true,
      },
      {
        path: "/users/:id/edit",
        name: "users.edit",
        component: UserCreate,
        props: true,
      },

      //Wallet
      {
        path: "/wallets",
        name: "wallets.view",
        component: WalletView,
      },

      //Tenant
      {
        path: "/atelier",
        name: "atelier.view",
        component: Atelier,
      },
      {
        path: "/atelier/edit",
        name: "atelier.edit",
        component: AtelierEdit
      }

    ],
  },

  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFoundView },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from) => {
  if (to.meta.requireAuth === true) {
    const isAuthenticated = isUserLoggedIn();

    if (
      // make sure the user is authenticated
      !isAuthenticated &&
      // ❗️ Avoid an infinite redirect
      to.name !== "login"
    ) {
      // redirect the user to the login page
      return { name: "login" };
    }

    if (to.name == "login" && isAuthenticated) {
      return from;
    }
  }
});

export default router;
